"use client";

export { createColumnsFromConfig } from "./columnFactory/createColumnsFromConfig";
